const MainMenuSetup = [
  { pid: null, id: '0',  title: 'Dashboard', path: '/' },
  { pid: null, id: '1',  title: '管理员' },
  { pid: '1', id: '1-1', title: '管理员列表', path: '/admins/list' },
  { pid: '1', id: '1-2', title: '添加/修改管理员' },
  { pid: '1-2', id: '1-2-1', title: '已添加的管理员' },
  { pid: '1-2-1', id: '1-2-1-1', title: '已添加的管理员2', path: '/admins/add' },
  { pid: null, id: '2',  title: '导航菜单' },
  { pid: '2', id: '2-1', title: '导航菜单列表', path: '/menu/list' },
  { pid: '2', id: '2-2', title: '添加/修改导航菜单', path: '/menu/add' },
  { pid: '2', id: '2-3', title: 'SALARY', path: '/salary' },
  // { pid: null, id: '3',  title: '首页海报管理' },
  // { pid: '3', id: '3-1', title: '海报列表', path: '/banner/list' },
  // { pid: '3', id: '3-2', title: '添加/修改海报', path: '/banner/add' },
  { pid: null, id: '4',  title: '电影管理' },
  { pid: '4', id: '4-1', title: '电影列表', path: '/movie/list/1' },
  { pid: '4', id: '4-2', title: '添加/修改电影', path: '/movie/add' },
  { pid: null, id: '5',  title: '日记管理' },
  { pid: '5', id: '5-1', title: '日记列表', path: '/diary/list/1' },
  { pid: '5', id: '5-2', title: '添加/修改日记', path: '/diary/add' },
  { pid: null, id: '6',  title: '运动管理' },
  { pid: '6', id: '6-1', title: '日常跑步列表', path: '/dailyRun/list' },
  { pid: '6', id: '6-2', title: '添加/修改日常跑步', path: '/dailyRun/add' },
  { pid: '6', id: '6-3', title: '马拉松列表', path: '/marathon/list' },
  { pid: '6', id: '6-4', title: '添加/修改马拉松', path: '/marathon/add' },
  // { pid: null, id: '7',  title: '西点管理' },
  // { pid: '7', id: '7-1', title: '西点制作列表', path: '/cake/making/list' },
  // { pid: '7', id: '7-2', title: '添加/修改西点制作', path: '/cake/making/add' },
  // { pid: null, id: '8',  title: '好物管理' },
  // { pid: '8', id: '8-1', title: '好物列表', path: '/haowu/list' },
  // { pid: '8', id: '8-2', title: '添加/修改好物', path: '/haowu/add' },
  { pid: null, id: '9',  title: '油价管理' },
  { pid: '9', id: '9-1', title: '油价列表', path: '/petrol/list/1' },
  { pid: '9', id: '9-2', title: '添加/修改油价', path: '/petrol/add' },
  /////////////////////////////////////////////////////////////////////
  { pid: null, id: '10',  title: '跨境电商' },
  { pid: '10', id: '10-cr-list', title: '汇率列表', path: '/amazon/currencyRate/list/1' },
  { pid: '10', id: '10-cr-add', title: '添加/修改汇率', path: '/amazon/currencyRate/add' },
  { pid: '10', id: '10-rent', title: '店租列表', path: '/amazon/rent/zgf/list/1' },
  { pid: '10', id: '10-total', title: '(总)亚马逊订单列表', path: '/amazon/aliexpress/totals/list/1' },
  { pid: '10', id: '10-zgf-list', title: 'Z店订单列表', path: '/amazon/aliexpress/zgf/list/1' },
  { pid: '10', id: '10-zgf-add', title: 'Z店订单-添加/修改', path: '/amazon/aliexpress/zgf/add' },
  { pid: '10', id: '10-ljl-list', title: 'L店订单列表', path: '/amazon/aliexpress/ljl/list/1' },
  { pid: '10', id: '10-ljl-add', title: 'L店订单-添加/修改', path: '/amazon/aliexpress/ljl/add' },
  { pid: '10', id: '10-a-list', title: 'A店订单列表', path: '/amazon/aliexpress/a/list/1' },
  { pid: '10', id: '10-a-add', title: 'A店订单-添加/修改', path: '/amazon/aliexpress/a/add' },
  { pid: '10', id: '10-tFanHongGui-list', title: '樊宏贵店订单列表', path: '/amazon/aliexpress/t_FanHongGui/list/1' },
  { pid: '10', id: '10-tFanHongGui-add', title: '樊宏贵店订单-添加/修改', path: '/amazon/aliexpress/t_FanHongGui/add' },
  { pid: '10', id: '10-tFuKeZhou-list', title: '符克周店订单列表', path: '/amazon/aliexpress/t_FuKeZhou/list/1' },
  { pid: '10', id: '10-tFuKeZhou-add', title: '符克周店订单-添加/修改', path: '/amazon/aliexpress/t_FuKeZhou/add' },
  { pid: '10', id: '10-tHuangWei-list', title: '黄伟店订单列表', path: '/amazon/aliexpress/t_HuangWei/list/1' },
  { pid: '10', id: '10-tHuangWei-add', title: '黄伟店订单-添加/修改', path: '/amazon/aliexpress/t_HuangWei/add' },
  { pid: '10', id: '10-tSunZhenYu-list', title: '孙震宇店订单列表', path: '/amazon/aliexpress/t_SunZhenYu/list/1' },
  { pid: '10', id: '10-tSunZhenYu-add', title: '孙震宇店订单-添加/修改', path: '/amazon/aliexpress/t_SunZhenYu/add' },
  /////////////////////////////////////////////////////////////////////
  { pid: null, id: '11',  title: '云途物流' },
  { pid: '11', id: '11-1', title: '充值列表', path: '/yunexpress/list/1' },
  { pid: '11', id: '11-2', title: '添加/修改充值', path: '/yunexpress/add' },
  // { pid: null, id: '80',  title: '测试管理' },
  // { pid: '80', id: '80-1', title: '测试内容列表', path: '/test/list' },
  // { pid: '80', id: '80-2', title: '添加/修改测试内容', path: '/test/add' },
]

export default MainMenuSetup
